module.exports = __webpack_public_path__ + "assets/img/1.4e91ca44.jpg";